import { LabelEnum } from 'app/shared/enums';
import { isEmailValid } from 'app/validators/validateEmail';

const email = (value: string) => {
  return isEmailValid(value, true) ? undefined : LabelEnum.InvalidEmail;
};

export default email;
